import React from "react";
import { indexStore } from "../../store/indexStore";
import AudioNotification from "./AudioNotification";

const NotificationManager = () => {
  const { isNotificationVisible } = indexStore();

  if (!isNotificationVisible) {
    return null;
  }

  return <AudioNotification />;
};

export default NotificationManager;
